import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { AppService } from "../services/app.service";
import { environment } from "../../environments/environment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { SupportService } from "../services/support-service";

@Component({
  selector: "app-profile-form",
  templateUrl: "./profile-form.component.html",
})
export class ProfileFormComponent implements OnInit {
  @ViewChild("validationPopup") validationPopup: TemplateRef<any>;
  @ViewChild("genderModal") genderModal: TemplateRef<any>;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  path: any;
  scheduleappointmentid: any = "";
  profileFormSubmitted = false;
  profileForm: FormGroup;
  today: any = new Date();
  carouselTile: any;
  carouselTileItems: any;
  validationMessage: any = {};
  countryList: any = [];
  scheduledData: any = {};
  selectedlang: any;
  cptCodeList: any = [];
  selectedprocedureList: any = [];
  scheduledpatient: any = [];
  scheduleDateShow: any;
  validationAlertDisplay = false;
  timezone_offset_min: any;
  offset_hrs: any;
  offset_min: any;
  lat: number;
  lng: number;
  phonemask = "00000-00000";
  patientData: any;

  primaryEmailValidationmessage: "";
  config = {
    ignoreBackdropClick: true,
  };
  showExamdetails = false;
  constructor(
    private appservice: AppService,
    private datePipe: DatePipe,
    private router: Router,
    private modalService: BsModalService,
    private profileInfo: FormBuilder,
    private toastr: ToastrService,
    private supportService: SupportService
  ) {
    this.today.setHours(0, 0, 0, 0);
    this.profileForm = profileInfo.group({
      email: [
        "",
        [Validators.required, Validators.pattern(environment.emailPattern)],
      ],
      countrydialcode: ["default"],
      phonenumber: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      gender: ["default"],
      phonemask: ["0000000000"],
    });
  }

  isMobile = false;
  ngOnInit() {
    if (window.screen.width <= 540) {
      this.isMobile = true;
    }
    this.getLanguage();
    this.getcountry();
    this.supportService.patientname.next("");
    sessionStorage.getItem("scheduleData") != null
      ? (this.scheduledData = JSON.parse(
          sessionStorage.getItem("scheduleData")
        ))
      : (this.scheduledData = []);
    this.selectedprocedureList = this.scheduledData.selectProcedureList;
    this.scheduledpatient = this.scheduledData;
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 3) {
      this.scheduleappointmentid = Splitpath[2];
      this.viewscheduleapp();
    } else {
      sessionStorage.getItem("patientData") !== null
        ? (this.patientData = JSON.parse(sessionStorage.getItem("patientData")))
        : (this.patientData = null);
      if (this.patientData) {
        if (this.patientData.patientPhoneCode === "+91") {
          this.phonemask = "00000-00000";
        } else {
          this.phonemask = "(000) 000-0000";
        }
        this.profileForm["controls"]["email"].setValue(
          this.patientData.patientEmail
        );
        this.profileForm["controls"]["countrydialcode"].setValue(
          this.patientData.patientPhoneCode
        );
        this.profileForm["controls"]["firstName"].setValue(
          this.patientData.firstName
        );
        this.profileForm["controls"]["lastName"].setValue(
          this.patientData.lastName
        );
        this.profileForm["controls"]["gender"].setValue(
          this.patientData.gender
        );
        this.profileForm["controls"]["phonemask"].setValue(this.phonemask);
        this.profileForm["controls"]["phonenumber"].setValue(
          this.patientData.patientPhone
        );
      } else {
        if (this.scheduledData.countryCode === "IN") {
          this.profileForm.controls.countrydialcode.setValue("+91");
          this.phonemask = "00000-00000";
        } else {
          this.profileForm.controls.countrydialcode.setValue("+1");
          this.phonemask = "(000) 000-0000";
        }
      }
    }
    this.gettestcentersbycriteria();

    this.supportService.headerSignBtnHandle.next(false);
  }
  showExams() {
    this.showExamdetails = true;
  }

  gotoNextFocus() {
    if (this.profileForm.controls["gender"].value === "default") {
      this.openGenderPopup();
    }
  }

  hideExams() {
    this.showExamdetails = false;
  }

  openGenderPopup() {
    this.openModal(this.genderModal);
  }

  selectGenderValue(value) {
    this.profileForm["controls"]["gender"].setValue(value);
    this.modalRef.hide();
  }

  goBack() {
    this.router.navigate(["/home"]);
  }

  convetTimeZoneOffsetToTime() {
    this.timezone_offset_min = new Date().getTimezoneOffset();
    this.offset_hrs = Math.abs(this.timezone_offset_min / 60);
    this.offset_min = Math.abs(this.timezone_offset_min % 60);
    let timezone_standard = "";

    if (this.offset_hrs < 10) {
      this.offset_hrs = "0" + Math.floor(this.offset_hrs);
    }

    if (this.offset_min < 10) {
      this.offset_min = "0" + this.offset_min;
    }

    // Add an opposite sign to the offset
    // If offset is 0, it means timezone is UTC
    if (this.timezone_offset_min < 0) {
      timezone_standard =
        "+" + this.offset_hrs.toString() + ":" + this.offset_min.toString();
    } else if (this.timezone_offset_min > 0) {
      timezone_standard =
        "-" + this.offset_hrs.toString() + ":" + this.offset_min.toString();
    } else if (this.timezone_offset_min === 0) {
      timezone_standard = "+00:00";
    }
    return timezone_standard.toString();
  }

  viewscheduleapp() {
    this.appservice
      .viewscheduleappointmentpro(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"] && res["entity"].schedule) {
            if (res["entity"].schedule.patientPhoneCode === "+91") {
              this.phonemask = "00000-00000";
            } else {
              this.phonemask = "(000) 000-0000";
            }
            this.profileForm["controls"]["email"].setValue(
              res["entity"].schedule.patientEmail
            );
            this.profileForm["controls"]["countrydialcode"].setValue(
              res["entity"].schedule.patientPhoneCode
            );
            this.profileForm["controls"]["firstName"].setValue(
              res["entity"].schedule.patientFirstName
            );
            this.profileForm["controls"]["lastName"].setValue(
              res["entity"].schedule.patientLastName
            );
            this.profileForm["controls"]["gender"].setValue(
              res["entity"].schedule.patientGender
            );
            this.profileForm["controls"]["phonemask"].setValue(this.phonemask);
            this.profileForm["controls"]["phonenumber"].setValue(
              res["entity"].schedule.patientPhone
            );
          }
        } else {
          this.router.navigate(["/home"]);
        }
      });
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res["validationMessage"] && res["commonMsg"]) {
        this.validationMessage = res["validationMessage"];
        this.selectedlang = res["commonMsg"];
      }
    });
  }

  gettestcentersbycriteria() {
    if (this.scheduledData) {
      const data = {
        scheduleOn: this.scheduledData.scheduleOn,
        scheduleOnStr: this.scheduledData.scheduleOnStr,
        location: this.scheduledData.location,
        dayOfweek: this.scheduledData.dayOfweek,
        payMode: this.scheduledData.payMode,
        insurance: this.scheduledData.insuranceId,
        inType: this.scheduledData.inType,
        cptCodes: this.scheduledData.cptCodeList,
        latitude: this.scheduledData.latitude,
        longitude: this.scheduledData.longitude,
        today: this.scheduledData.today,
        timeZone: "",
        currentTime: this.scheduledData.currentTime,
      };
      this.appservice.gettestcentersbycriteria(data).subscribe((res) => {
        if (res && res["entity"]) {
          sessionStorage.setItem(
            "testCenterByCriteria",
            JSON.stringify(res["entity"])
          );
        }
      });
    }
  }

  closeTrigger(value) {
    document.getElementById(value).click();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  openModal2(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }
  closemodel2() {
    this.modalRef2.hide();
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {backdrop : 'static', keyboard : false, class: 'popup-center-new modal-lg' });
  }

  closemodel() {
    this.modalRef.hide();
  }

  changeCountry(countryid) {
    if (countryid) {
      if (countryid === "101" || countryid === 101) {
        this.profileForm.controls["countrydialcode"].setValue("+91");
        this.phonemask = "00000-00000";
      } else if (countryid === "231" || countryid === 231) {
        this.profileForm.controls["countrydialcode"].setValue("+1");
        this.phonemask = "(000) 000-0000";
      }
    }
  }

  changeMask(type, value) {
    if (type === "phonemask") {
      const phonenumber = this.profileForm.get("phonenumber").value;
      this.phonemask = this.appservice.checkDialCode(value);
      this.profileForm.controls["phonenumber"].setValue(phonenumber);
    }
  }

  checkEmailValidationMessage(value) {
    if (this.profileFormSubmitted) {
      if (value.toString().trim()) {
        const email = value.toString().trim();
        if (email.match(environment.emailPattern)) {
          this.validationMessage.primaryEmailValidationmessage = "";
        } else {
          this.validationMessage.primaryEmailValidationmessage = this.validationMessage.validEmail;
        }
      } else if (!value.toString().trim()) {
        this.validationMessage.primaryEmailValidationmessage = this.validationMessage.emailid;
      } else {
        this.validationMessage.primaryEmailValidationmessage = "";
      }
    }
  }

  getcountry() {
    this.appservice.getCountry().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.countryList = res["entity"];
        } else {
          this.countryList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  submit() {
    if (this.isMobile) {
      if (
        this.profileForm.controls["gender"].value === "default" ||
        !this.profileForm.controls["gender"].value
      ) {
        this.openModal(this.genderModal);
        return;
      }
    }

    let valid = false;
    this.profileFormSubmitted = true;
    if (
      this.profileForm.controls["firstName"].value &&
      this.profileForm.controls["email"].value.match(
        environment.emailPattern
      ) &&
      this.profileForm.controls["lastName"].value &&
      this.profileForm.controls["gender"].value !== "default" &&
      this.profileForm.controls["email"].value &&
      this.profileForm.controls["countrydialcode"].value &&
      this.profileForm.controls["phonenumber"].value &&
      this.profileForm.controls["phonenumber"].value.length == 10 &&
      this.profileFormSubmitted
    ) {
      valid = true;
    }

    if (valid) {
      this.validationAlertDisplay = false;
      const data = {
        patientFirstName: this.profileForm.get("firstName").value,
        patientLastName: this.profileForm.get("lastName").value,
        patientEmail: this.profileForm.get("email").value,
        patientPhoneCode: this.profileForm.get("countrydialcode").value,
        patientPhone: this.profileForm.get("phonenumber").value,
        patientId: "",
        gender: this.profileForm.get("gender").value,
      };
      this.appservice.addorupdatepatient(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            if (
              this.scheduleappointmentid &&
              this.scheduleappointmentid !== ""
            ) {
              this.router.navigate([
                "/selection-screen",
                this.scheduleappointmentid,
              ]);
            } else {
              this.router.navigate(["/selection-screen"]);
            }
            res["entity"]["firstName"] = this.profileForm.get(
              "firstName"
            ).value;
            res["entity"]["lastName"] = this.profileForm.get("lastName").value;
            sessionStorage.setItem(
              "patientData",
              JSON.stringify(res["entity"])
            );
          }
        },
        (err) => {
          this.profileFormSubmitted = false;
          this.appservice.sessionOut(err);
        }
      );
    } else {
      this.validationAlertDisplay = true;
      this.toastr.error("Please fill all the highlighted fields ");
      if (!this.profileForm.get("email").value) {
        this.validationMessage.primaryEmailValidationmessage = this.validationMessage.emailid;
        this.validationMessage.primaryphonenumbermessage =
          "Phone number is required";
      }
    }
  }

  primaryphonenumberValidationMessage() {
    if (
      this.profileForm.controls["phonenumber"].value &&
      this.profileFormSubmitted
    ) {
      if (this.profileForm.get("phonenumber").hasError("minlength")) {
        this.validationMessage.primaryphonenumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else if (this.profileForm.get("phonenumber").hasError("maxlength")) {
        this.validationMessage.primaryphonenumbermessage = this.validationMessage.phonemaxlengthvalidmessage;
      } else {
        this.validationMessage.primaryphonenumbermessage = "";
      }
    } else if (
      this.profileFormSubmitted &&
      !this.profileForm.controls["phonenumber"].value
    ) {
      this.validationMessage.primaryphonenumbermessage =
        "Phone number is required";
    } else {
      this.validationMessage.primaryphonenumbermessage = "";
    }
  }
}
